import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1f88c990"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f88c990')) {
      api.createRecord('1f88c990', component.options)
    } else {
      api.reload('1f88c990', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1f88c990", function () {
      api.rerender('1f88c990', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/quotationManagement/cmp/Transportation/index.vue"
export default component.exports